import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Icon, List, Popup } from 'semantic-ui-react'
import { upperFirst } from 'lodash'

class UserCardListItem extends Component {
  static propTypes = {
    item: PropTypes.string.isRequired,
    itemValue: PropTypes.number,
    remove: PropTypes.func.isRequired,
  }

  handleClick = e => {
    const { remove, item, itemValue } = this.props

    e.preventDefault()
    remove(itemValue || item)
  }

  render() {
    const { item } = this.props

    return (
      <List.Item key={item}>
        <a href="remove" onClick={this.handleClick}>
          <Popup content={`Remove ${upperFirst(item)}`} size="mini" trigger={<Icon name="x" />} />
        </a>
        {upperFirst(item)}
      </List.Item>
    )
  }
}

export default UserCardListItem
